var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/people"
  }, /*#__PURE__*/React.createElement("g", {
    id: "people"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.9998 11.932C29.8998 11.9154 29.7831 11.9154 29.6831 11.932C27.3831 11.8487 25.5498 9.96537 25.5498 7.63203C25.5498 5.2487 27.4665 3.33203 29.8498 3.33203C32.2331 3.33203 34.1498 5.26537 34.1498 7.63203C34.1331 9.96537 32.2998 11.8487 29.9998 11.932Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.2834 24.0656C30.5667 24.449 33.0834 24.049 34.8501 22.8656C37.2001 21.299 37.2001 18.7323 34.8501 17.1656C33.0667 15.9823 30.5167 15.5823 28.2334 15.9823",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.95078 11.932C10.0508 11.9154 10.1674 11.9154 10.2674 11.932C12.5674 11.8487 14.4008 9.96537 14.4008 7.63203C14.4008 5.2487 12.4841 3.33203 10.1008 3.33203C7.71745 3.33203 5.80078 5.26537 5.80078 7.63203C5.81745 9.96537 7.65078 11.8487 9.95078 11.932Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.6671 24.0656C9.38372 24.449 6.86706 24.049 5.10039 22.8656C2.75039 21.299 2.75039 18.7323 5.10039 17.1656C6.88372 15.9823 9.43372 15.5823 11.7171 15.9823",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.9998 24.3852C19.8998 24.3685 19.7831 24.3685 19.6831 24.3852C17.3831 24.3018 15.5498 22.4185 15.5498 20.0852C15.5498 17.7018 17.4665 15.7852 19.8498 15.7852C22.2331 15.7852 24.1498 17.7185 24.1498 20.0852C24.1331 22.4185 22.2998 24.3185 19.9998 24.3852Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.1502 29.6336C12.8002 31.2003 12.8002 33.7669 15.1502 35.3336C17.8169 37.1169 22.1835 37.1169 24.8502 35.3336C27.2002 33.7669 27.2002 31.2003 24.8502 29.6336C22.2002 27.8669 17.8169 27.8669 15.1502 29.6336Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.38aec2f21069e2aae4f47f8a57f81e48.svg";
export { ForwardRef as ReactComponent };